import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import {reducer as AuthReducer} from "./modules/auth/reducer";
import * as authActions from "./modules/auth/actions";
import {productsSlice} from "./modules/products/slices";
import {linksSlice} from "./modules/links/slices";
import {ordersSlice} from "./modules/orders/slices";
import {QNASlice} from "./modules/qna/slices";
import {samplesSlice} from "./modules/samples/slices";
import {CategoriesSlice} from "./modules/categories/slices";
import {balancesSlice} from "./modules/balances/slices";

export const rootReducer = combineReducers({
  auth: AuthReducer,
  products: productsSlice.reducer,
  links: linksSlice.reducer,
  orders: ordersSlice.reducer,
  qna: QNASlice.reducer,
  samples: samplesSlice.reducer,
  categories: CategoriesSlice.reducer,
  balances: balancesSlice.reducer,
});

export function* rootSaga() {
  yield all([authActions.saga()]);
}
